import React, { useState, useEffect, useContext, useMemo } from "react";

import {
  Card,
  Grid,
  IconButton,
  FormControl,
  TextField,
  MenuItem,
  InputAdornment,
  FormHelperText,
  CircularProgress,
  Button,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LocalConvenienceStoreOutlined } from "@material-ui/icons";
// import { ArrowUpwardSharp } from '@material-ui/icons';
import feedbackContext from "contexts/feedbackContext";
import UserContext from "contexts/userContext";
import { notify, closeSnack } from "utils/MyFunctions";
import FileUpload from "../../../../FileUpload";

export default function LivePreviewExample(props) {
  const intl = useIntl();
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Accept: "application/ld+json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    cache: "no-cache",
  };
  const [file, setFile] = useState({
    bl: "",
    name: "",
    b64: "",
  });
  const [gfile, setGFile] = useState();
  const [init, setInit] = useState();

  const [changes, setChanges] = useState(0);
  const { role, setRole, locale } = useContext(UserContext);

  const [blcheck, setBLCheck] = React.useState(false);

  const [blError, setBLError] = React.useState(false);
  const [blHelper, setBLHelper] = React.useState("");

  const [valid, setValid] = useState(false);
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext
  );

  useEffect(() => {
    if (Object.keys(props.data).length > 0) {
      setFile(props.data);
      setInit({ name: props.data.name });
    }
  }, [props.data]);

  useEffect(() => {
    console.log("gfile : ", gfile);
    if (gfile && gfile.file) {
      setFile({ ...file, ["name"]: gfile.file.name, ["b64"]: gfile.file.uuid });
    }
  }, [gfile]);

  useEffect(() => {
    let form = document.getElementById("file-form");

    let validity =
      file.bl !== "" && file.b64.length > 0 && !blcheck && !blError;
    console.log("validity of group files is : ", validity);
    console.log("setting files validity to : ", validity);
    setValid(validity);
    props.setValidity(validity);
    if (validity) {
      props.sendFile(file);
    }
  }, [file, blcheck]);

  const handleChange = (event) => {
    event.persist(event);
    setFile({ ...file, [event.target.name]: event.target.value });
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const debounceCheckBL = useMemo(
    () =>
      _.debounce(async (bl, carrier) => {
        console.log(" bl: ", bl);
        console.log(" carrier: ", carrier);
        try {
          console.log(
            "url : ",
            MONOLITH_API_URL + "/api/bescs?referenceDocChildNumber=" + bl.trim()
          );
          console.log("setting bl check to tru e");
          setBLCheck(true);
          const response = await fetch(
            MONOLITH_API_URL +
              "/api/bescs?referenceDocChildNumber=" +
              bl.trim(),
            requestOptions
          );

          //await sleep(1e3); // For demo purposes.
          let _shippers = await response.json();
          _shippers = _shippers["hydra:member"];
          if (_shippers.length > 0) {
            //DUPLICATE LOGIC
            // console.log("found matches : ", _shippers);
            // console.log("bl : ", bl);
            // console.log("carrier : ", carrier);
            // console.log("props.bescId : ", props.bescId);
            // console.log("condition : ", _shippers[0].carrier === carrier);

            let _match = _shippers.filter(
              (el) =>
                (props.bescId == null || parseInt(props.bescId) !== el.id) &&
                el.referenceDocChildNumber === bl &&
                el.carrier === carrier
            );
            console.log("match is : ", _match);
            if (_match.length > 0) {
              setBLError(true);
              setBLHelper(
                formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_transport_helper_existing_bl"
                )
              );
            } else {
              setBLError(false);
              setBLHelper("");
            }
          } else {
            setBLError(false);
            setBLHelper("");
          }
          setBLCheck(false);
        } catch {
          setBLCheck(false);
          (e) => {
            console.log("an error occured, details : ", e);
          };
        }
      }, 600),
    []
  );

  const uploadFile = async (event) => {
    const filenames = event.target.files;

    if (filenames[0].size > 2 * 1048576) {
      // 1 MB in bytes
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_alert_file_size"
        ),
        "info",
        "center",
        "bottom",
        true,
        enqueueSnackbar
      );
      event.target.value = ""; // clear the file input
    } else {
      // Handle the file upload logic here
      let fileName = filenames[0].name;
      let _b64 = await convertBase64(filenames[0]);
      setFile({ ...file, ["name"]: fileName, ["b64"]: _b64 });
    }
  };

  useEffect(() => {
    console.log("changes : ", changes);
    if (props.carrier !== "" && !!props.carrier && changes == 0) {
      console.log("new changes : ", changes + 1);
      setChanges(changes + 1);
    }
  }, [props.carrier]);

  useEffect(() => {
    if (
      ["ro-ro", "conteneur"].includes(props.conditionnement) &&
      file.bl !== "" &&
      !!file.bl &&
      props.carrier !== "" &&
      !!props.carrier &&
      changes == 1
    ) {
      console.log(
        "transporteur uuid : ",
        props.carrier ? props.carrier.uuid : null
      );
      debounceCheckBL(file.bl, props.carrier ? props.carrier.uuid : null);
    } else {
      setBLError(false);
      setBLHelper("");
    }
  }, [props.conditionnement, props.carrier]);

  // const addFile = () => {
  //   let _values = [...files];
  //   _values.push({});
  //   setFiles(_values);
  // };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(0),
    },
    withoutLabel: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },

    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <Card className="p-4 mb-4">
      {/* -------------------------------------- Fichiers ----------------------------------- */}
      <form id="file-form">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          alignSelf="center"
          spacing={2}
          xs={12}
        >
          <Grid item xs={4}>
            <FormControl
              fullWidth
              className={classes.margin}
              variant="outlined"
            >
              <TextField
                className="m-2"
                size="small"
                id="outlined-select-currency"
                required
                error={blError}
                label={formatMessage(
                  intl,
                  "create_besc_maritime_import_accordion_grouping_label_bl_number"
                )}
                InputProps={{
                  endAdornment: blcheck && (
                    <InputAdornment position="end">
                      <CircularProgress size={20} />
                    </InputAdornment>
                  ),
                  readOnly:
                    role.user && role.user.roles[0].name === "Modificateur",
                }}
                name="bl"
                value={file.bl}
                variant="outlined"
                onChange={(event) => {
                  handleChange(event);
                  if (
                    props.carrier !== "" &&
                    event.target.value !== "" &&
                    !!props.carrier &&
                    ["ro-ro", "conteneur"].includes(props.conditionnement) &&
                    !props.isGroup
                  ) {
                    console.log("IF, connaissement : ", file.bl);
                    console.log("debouncing check bl");
                    console.log("value bl : ", event.target.value);
                    console.log("props carrier : ", props.carrier);
                    debounceCheckBL(
                      event.target.value,
                      props.carrier ? props.carrier.uuid : null
                    );
                  }
                }}
              ></TextField>
              <FormHelperText error>
                {!blError ? null : blHelper}
              </FormHelperText>
            </FormControl>
          </Grid>

          <FileUpload
            fileSizeLimit={2 * 1048576}
            name={"name"}
            label={formatMessage(
              intl,
              "create_besc_maritime_import_accordion_grouping_label_file_name"
            )}
            id={"-groupage"}
            size={6}
            init={init}
            required={true}
            sendFile={(_file) => {
              setGFile(_file);
            }}
            onChange={() => {
              console.log("changed");
            }}
          />
        </Grid>
      </form>
    </Card>
  );
}
